import SelectDropdown from "src/components/dropdownComponent/dropdown";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { GetError } from "src/constant";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getMyData } from "src/thunks/auth";

export const DepotDropDown = ({
  depoDataShown,
  handleChange,
  depotDashboardDropdownValue,
  depotDropdownOpenFlag,
  handleDepotDropdownOpenChange,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  let userDetails = JSON.parse(localStorage.getItem("userDetails"))

  useEffect(() => {
    getAllMyData()
  }, [])

  const getAllMyData = async () => {
    try {
      let res = await dispatch(getMyData()).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    } finally {
    }
  };

  return (
    <div style={{ flex: 1, color: "white" }}>
      <SelectDropdown
        isSearchInputShown={false}
        data={userDetails?.roles == "DepotManager" && location.pathname == "/app/dashboard" ? depoDataShown : [{ name: "ALL DEPOTS", id: 0 }, ...depoDataShown]}
        value={depotDashboardDropdownValue.name}
        onValueChange={handleChange}
        depotDropdownOpenFlag={depotDropdownOpenFlag}
        handleDepotDropdownOpenChange={handleDepotDropdownOpenChange}
      />
    </div>
  );
};
